import React, { useContext } from "react";
import "./em-dashboard.css";
import EnergyData from "../../components/Energy-Mgmt/Energy-Data/energy-data";
import EngergyCostCmp from "../../components/Energy-Mgmt/Energy-Cost-Cmp/energy-cost-datagrid";
import EnergyAuditSummary from "../../components/Energy-Mgmt/Energy-Audit-Summary/energy-audit-summary";
import EnergyMonitorBar from "../../components/Energy-Mgmt/Energy-Monitoring/energy-monitoring";
import GroupRealtimePower from "../../components/Energy-Mgmt/Group-Realtime-Power/energy-cost-datagrid";
import PeakMonitoring from "../../components/Energy-Mgmt/Peak-Monitoring/peak-monitoring";
import GaugePowerGenerator from "../../components/Energy-Mgmt/Power-Generation/power-generation";
import Card3 from "../../components/Energy-Mgmt/EMCard/em-card";
import EnergyCostComp from "../../components/Custom-Chart-5/energy-datagrid";
import ENPI_MONITORING from "../../components/Energy-Mgmt/Enpi-Monitoring/enpi-monitoring";
import PowerDemand from "../../components/Energy-Mgmt/Power-Demand/power-demand";
import KPIChart from "../../components/Energy-Mgmt/KPI-Chart/kpi-chart";
import EngergyDataCmp from "../../components/Energy-Mgmt/Energy_Data_Comp/energy-data-comp";
import Filters from "../../components/Filters/filters";
import Navbar from "../../components/Navbar/navbar";
import { RootContext } from "../../contexts/root-context";
import NotificationExample from "../../components/Notification/notification";
import UserSession from "../../components/Authentication/user-session";
import PageInfoDialog from "../../components/PageInfoDialog/PageInfoDialog";
import { PAGE_INFO_DATA } from "../../utils/pageInfoData";

function EMDashboard() {
    const { isnotify } = useContext(RootContext);
    
    return (
        <>
            {isnotify === "true" ? <NotificationExample notitype={isnotify} /> : ""}
            {isnotify === "error" ? <NotificationExample notitype={isnotify} /> : ""}

            {/* Page Info Icon - Fixed Position Top Right */}
            <PageInfoDialog pageData={PAGE_INFO_DATA['em']} pageKey="em" />

            <UserSession />
            <Navbar />
            <Filters />
            
            <div className="widget-container">
                <Card3
                    widgetName="Energy Performance Indicator"
                    widgetUpdateTime="2"
                    component={<KPIChart />}
                    applyScroll="true"
                ></Card3>
                <Card3
                    widgetName="Energy Monitoring"
                    widgetUpdateTime="2"
                    component={<EnergyMonitorBar />}
                    applyScroll="true"
                ></Card3>
                <Card3
                    widgetName="Energy Data"
                    widgetUpdateTime="2"
                    component={<EnergyData />}
                    applyScroll="true"
                ></Card3>
                <Card3
                    widgetName="Energy Cost Comparison"
                    widgetUpdateTime="2"
                    isTimePeriod={true}
                    component={<EnergyCostComp />}
                    applystyle="true"
                ></Card3>
                <Card3
                    widgetName="EnPI Monitoring"
                    widgetUpdateTime="2"
                    component={<ENPI_MONITORING />}
                    applyScroll="true"
                ></Card3>
                <Card3
                    widgetName="Power Demand"
                    widgetUpdateTime="2"
                    component={<PowerDemand />}
                    applyScroll="true"
                ></Card3>
                <Card3
                    widgetName="Power Generation"
                    widgetUpdateTime="2"
                    component={<GaugePowerGenerator />}
                    applyScroll="true"
                ></Card3>
                <Card3
                    widgetName="Peak Monitoring"
                    widgetUpdateTime="2"
                    component={<PeakMonitoring />}
                    applyScroll="true"
                ></Card3>
                <Card3
                    widgetName="Energy Data Comparison"
                    widgetUpdateTime="2"
                    component={<EngergyDataCmp />}
                    applystyle="true"
                ></Card3>
                <Card3
                    widgetName="Group Realtime Power"
                    widgetUpdateTime="2"
                    component={<GroupRealtimePower />}
                    applystyle="true"
                ></Card3>
                <Card3
                    widgetName="Energy Audit Summary"
                    widgetUpdateTime="2"
                    component={<EnergyAuditSummary />}
                    applystyle="true"
                ></Card3>
            </div>
        </>
    );
}

export default EMDashboard;
